/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_VenuesInputs */

const cs_nav_venues = /** @type {(inputs: Nav_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočky`)
};

const en_nav_venues = /** @type {(inputs: Nav_VenuesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offices`)
};

/**
* | output |
* | --- |
* | "Offices" |
*
* @param {Nav_VenuesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_venues = /** @type {((inputs?: Nav_VenuesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_VenuesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_venues(inputs)
	return cs_nav_venues(inputs)
});